import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 20000);
    return () => clearTimeout(timer);
  }, []);
  return <AnimatePresence data-id="element-151">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-gradient-to-t from-ink/95 via-ink/85 to-transparent pointer-events-none" data-id="element-152">
          <div className="flex justify-center pointer-events-auto" data-id="element-153">
            <a href="#oferta" className="inline-flex items-center gap-2.5 bg-gold text-ink px-8 py-4 rounded-full no-underline text-base font-semibold shadow-[0_4px_20px_rgba(184,137,75,0.4)] transition-all duration-250 hover:bg-gold-light hover:-translate-y-0.5 group border-none cursor-pointer tracking-[0.01em]" data-id="element-154">
              Quiero entender el origen
              <span className="transition-transform duration-250 group-hover:translate-x-1" data-id="element-155">
                →
              </span>
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}